module.exports = new __parcel__URL__("lune-pluie-1.37e1dd31.svg").toString();